import React from "react";
import { Paper, Box, CircularProgress } from "@mui/material";
import { DashboardCardProps } from "../../../@types/ComponentsInterface/DashboardCardProps";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from '@fortawesome/free-solid-svg-icons';

const extractStrokeColor = (backgroundColor: string) => {
  const rgbColor = backgroundColor.slice(0, -2);
  return rgbColor;
};

const DashboardCard: React.FC<DashboardCardProps> = ({
  heading,
  backgroundColor,
  data,
  imgSrc,
  increment,
  loading,
}) => {
  const strokeColor = extractStrokeColor(backgroundColor);

  return (
    <Box
   
      sx={{
       
        "& > :not(style)": {
        
          width: "100%",
          height: "100%",
      
        },
      }}
    >
      <Paper
        elevation={6}
        sx={{
          boxShadow: "0px 7px 29px 0px #64646F33",
          borderRadius: "8px",
          backgroundColor: backgroundColor,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding:'10px',
        }}
      >
      
        <div
          style={{
            textAlign: "left",
            marginBottom: "16px",
            fontWeight: "bold",
            fontSize: "20px",
            color: "#fff",
          }}
          
        >
          {heading}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            flexGrow: 1,
            fontSize: "36px",
            fontWeight: "bold",
            color: "#fff",
            textAlign: "left",
          }}
           className="mb-4"
        >
          {loading ? (
            <CircularProgress sx={{ color: strokeColor }} />
          ) : (
            <p>
            <FontAwesomeIcon icon={faUsers} /> <span>{data}</span>
            </p>
          )}
        </div>

        {/* Optional Icon Section */}
        {imgSrc && (
          <div style={{ textAlign: "right" }}>
            <img
              src={imgSrc}
              alt=""
              style={{
                backgroundColor: backgroundColor,
                width: "20px",
              }}
            />
          </div>
        )}
      </Paper>
    </Box>
  );
};

export default DashboardCard;
